import { SET_MODAL } from '../constants';

export const showModal = (key, data = {}) => ({ type: SET_MODAL, key, val: true, data });

export const hideModal = payload => ({ type: SET_MODAL, key: payload, val: false });

/* export const setVisible = (state, id) => { return (state[id] || false)} */
